import { call, put, takeLatest, all } from "redux-saga/effects";

import { Paginated } from "@/jenesys-types/data/common";
import { DataType } from "@/jenesys-types/data/enums";
import { Client, User } from "@/jenesys-types/jenesys-entities/config";

import { performDataAction } from "@/services/api";

import {
  fetchOperatorData,
  fetchOperatorDataSuccess,
  fetchOperatorDataFailure,
  PracticeWithClients
} from "./operator";

function* fetchOperatorDataSaga() {
  try {
    // Step 1: Fetch current user information
    const user: User = yield call(performDataAction, DataType.User, "list", {});

    // Step 2: Get all practices the user is a member of
    const practices = user.companies || [];

    // Step 3: For each practice, fetch all its clients in parallel
    const practicesWithClientsPromises = practices.map((practice) =>
      call(performDataAction, DataType.Clients, "getClientsWithParams", {
        companyId: practice.id,
        search: "", // Empty search to get all clients
        limit: 1000,
        offset: 0
      })
    );

    const clientsResponses: Paginated<Client>[] = yield all(
      practicesWithClientsPromises
    );

    // Step 4: Combine practices with their clients
    const practicesWithClients: PracticeWithClients[] = practices.map(
      (practice, index) => {
        const clientsResponse = clientsResponses[index];
        const clients = clientsResponse?.items || [];
        
        return {
          practice,
          clients: Array.isArray(clients) ? clients : []
        };
      }
    );

    yield put(
      fetchOperatorDataSuccess({
        user,
        practicesWithClients
      })
    );
  } catch (error: any) {
    yield put(
      fetchOperatorDataFailure({
        error: {
          message: error.message || "Failed to fetch operator data",
          code: error.code || "FETCH_OPERATOR_DATA_ERROR"
        }
      })
    );
  }
}

export default function* operatorSaga() {
  yield takeLatest(fetchOperatorData.type, fetchOperatorDataSaga);
}